import { axiosInstance } from "./apiConfig"

export const apiDeleteBooking = async ({ storeId, bookingCode }) => {
    try {
        const response = await axiosInstance.post(
            `/thirdparty/resdiary/store/${storeId}/booking/${bookingCode}/cancel`,
            { cancellationReasonId: '' }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/api/apiDeleteBooking.js